import React, {
  Fragment,
  useState,
  forwardRef,
  useContext,
  useEffect,
} from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import {
  Search,
  Person,
  // AddCircle
} from "@material-ui/icons";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import axios from "axios";
import MaterialTable from "material-table";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
//import Button from "@material-ui/core/Button";

//import DeleteProfileAdmin from "views/dialog/DeleteProfileAdmin";
//import NewGenderAdmin from "views/dialog/NewGenderAdmin";
import imgLoader from "assets/img/progress.gif";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function ProfilesListAdmin() {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  //const [idRow, setIdRow] = useState("");
  //const [openDelete, setOpenDelete] = useState(false);
  const [openBackdrop, setoOpenBackdrop] = useState(false);
  //const [openNew, setopenNew] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const tableIcons = {
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  };

  const [state] = useState({
    columns: [
      {
        title: "ID",
        field: "id",
        width: "5%",
        cellStyle: {
          // whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
          textAlign: "CENTER",
        },
      },
      {
        title: "Nombre",
        field: "name",
        width: "30%",
        cellStyle: {
          // whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
        },
      },
      {
        title: "Estado",
        field: "status",
        render: (rowData) => {
          const text = rowData.status === "1" ? "ACTIVO" : "INACTIVO";
          const color = rowData.status === "1" ? "green" : "red";
          return (
            <center>
              <b style={{ color: color }}>{text}</b>
            </center>
          );
        },
        cellStyle: {
          // whiteSpace: "nowrap",
          border: "1px solid rgb(241, 241, 241)",
          fontSize: 14,
        },
      },
    ],
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dataRows();
  }, []);

  const dataRows = () => {
    axios
      .get(
        `${urlServices}routes_profile.php?keyAplication=${keyAplication}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setRows(response.data.rows);
        setLoader(false);
        setoOpenBackdrop(false);
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 200);
        } else {
          setRows([]);
          setError(true);
        }
      });
  };

  /*const RefreshTable = () => {
    setoOpenBackdrop(true);

    dataRows();
  };*/

  /*const handleCloseDelete = () => {
    setOpenDelete(false);
  };*/

  /*const handleCloseNew = () => {
    setopenNew(false);
  };*/

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="info">
            <div className={classes.cardTitleWhite}>
              <Person className={classes.iconWhite} /> Listado de perfiles
            </div>
          </CardHeader>
          <CardBody>
            {error ? (
              <Alert severity="error">
                Error en la consulta con sel servidor.
              </Alert>
            ) : (
              ""
            )}
            {loader ? (
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Box sx={{ width: "100%" }}>
                    <center>
                      <img
                        src={imgLoader}
                        alt="loader"
                        style={{
                          width: 50,
                          margin: "100px 0",
                          objectFit: "contain",
                        }}
                      />
                    </center>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Fragment>
                {/*<Grid container>
                  <Grid item xs={12} sm={12}>
                    <Button
                      className={classes.buttonRight}
                      onClick={(event) => {
                        setopenNew(true);
                      }}
                      startIcon={<AddCircle />}
                    >
                      Agregar género
                    </Button>
                  </Grid>
                </Grid>*/}
                <MaterialTable
                  title=""
                  columns={state.columns}
                  style={{
                    boxShadow: "unset",
                    border: "1px solid rgb(241, 241, 241)",
                  }}
                  data={rows}
                  localization={{
                    pagination: {
                      labelRowsSelect: "Filas",
                      labelDisplayedRows: " {from}-{to} de {count}",
                      firstTooltip: "Primera página",
                      previousTooltip: "Previo",
                      nextTooltip: "Siguiente",
                      lastTooltip: "Ultima página",
                    },
                    toolbar: {
                      // nRowsSelected: '{0} row(s) selected',
                      searchTooltip: "Filtrar",
                      searchPlaceholder: "Buscar",
                    },
                    header: {
                      actions: " --- ",
                    },
                    body: {
                      emptyDataSourceMessage: "No hay datos.",
                      filterRow: {
                        filterTooltip: "Filtro",
                      },
                    },
                  }}
                  actions={
                    [
                      /* {
                      icon: "search",
                      tooltip: "Ver",
                      onClick: (event, rowData) => {
                        setopenViewUser(true);
                        setIdRow(rowData);
                      },
                    },*/
                      /*{
                        icon: "edit",
                        tooltip: "Editar",
                        onClick: (event, rowData) => {
                          setOpenEdit(true);
                          setIdRow(rowData);
                        },
                      },*/
                      /*{
                        icon: "delete",
                        tooltip: "Eliminar",
                        onClick: (event, rowData) => {
                          setOpenDelete(true);
                          setIdRow(rowData);
                        },
                      },
                    (rowData1) => ({
                      icon: () => <Cancel />,
                      tooltip: "Deshabilitar",
                      onClick: (event, rowData) => {
                        setOpenDelete(true);
                        setIdRow(rowData);
                      },
                      hidden: rowData1.status === 1 ? false : true,
                    }),
                    {
                      icon: "refresh",
                      tooltip: "Refresh Data",
                      isFreeAction: true,
                      onClick: () => RefreshTable(),
                    },*/
                    ]
                  }
                  icons={tableIcons}
                  options={{
                    search: true,
                    padding: "default",
                    filtering: false,
                    actionsColumnIndex: -1,
                    pageSize: 10,
                    headerStyle: {
                      background: "#F2F2F2",
                      padding: "1%",
                      fontWeight: "bold",
                      textAlign: "center",
                    },
                    cellStyle: { border: "1px solid #DDDDDD" },
                  }}
                />
              </Fragment>
            )}
          </CardBody>
        </Card>
      </GridItem>
      {/*openDelete ? (
        <DeleteProfileAdmin
          open={openDelete}
          exit={handleCloseDelete}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      ) : (
        ""
      )*/}
      {/*openNew ? (
        <NewGenderAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      ) : (
        ""
      )*/}
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </GridContainer>
  );
}
